import { SportTypeEnum } from './enums/sportType';

export const LIST_COUNT_PER_PAGE = 10;
export const commonSportTypes = [SportTypeEnum.ESport, SportTypeEnum.Sport, SportTypeEnum.UnknownSport];
